/* start Pre-Application Form */
jQuery(function($) {
    if ($('.pre-app-form').length === 0) return; // only run on pre-app forms

    // When form validation fails, the form html is reset and gform_post_render runs again.
    // We need to reset the event listeners when that happens.
    $(document).on('gform_post_render', function() { // trigger on form or form page render
        $(".calc-block .gfield:not('.loan-amount') input").attr("readonly", false);

        // setTimeout(() => {
        //     $('.zip-format input').mask("99999",{ "placeholder": "" }); // remove underscores
        // }, 500);

        const backBtnLink = $('.af-single-form__form').data('back-btn');
        if (backBtnLink) {
            const backBtn = `<a href="${backBtnLink}" class="gform_previous_button custom-back-btn">Back</a>`;
            setTimeout(() => { // hacky fix - gravity disables/overrides the custom button, so we need to add it after initial load
                $('.pre-app-form .gform_body').find('.gform_page').first().find('.gform_page_footer').prepend(backBtn);
            }, 300);
        }

        setTimeout(() => {
            $('.pre-app-form').removeClass('no-transition'); // allow animation after page load
        }, 500);

        $('.money-format input, .number-format input').on('input', function() {
            formatCurrency($(this));
        });

        function formatNumber(n) { // format number 1234567 to 1,234,567
            if (typeof n !== 'string') n = n.toString();
            return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }

        function formatCurrency(input) { // formats number and puts cursor back in right position.
            let inputVal = input.val();
            const originalLength = inputVal.length;
            let caretPosition = input.prop("selectionStart");

            inputVal = formatNumber(inputVal);
            input.val(inputVal);

            // put caret back in the right position if we have one
            if (caretPosition) {
                const updatedLength = inputVal.length;
                caretPosition = updatedLength - originalLength + caretPosition;
                input[0].setSelectionRange(caretPosition, caretPosition);
            }
        }

        if ($('.pre-app-form .calc-block').length > 0) {
            // color "filled" part of the range
            let dpr = $('input[type="range"]#down-payment-range')[0];
            if (dpr) {
                dpr.style.setProperty('--value', dpr.value);
                dpr.style.setProperty('--min', dpr.min == '' ? '0' : dpr.min);
                dpr.style.setProperty('--max', dpr.max == '' ? '100' : dpr.max);
                dpr.addEventListener('input', () => dpr.style.setProperty('--value', dpr.value));
            }

            // calculate and format values
            let loanEl = $('.calc-block .loan-amount input');
            let homeEl = $('.calc-block .home-price input');
            let downEl = $('.calc-block .down-pay input');
            let downPercentEl = $('.calc-block .down-pay-percent input');
            let downPercentRangeEl = $('.calc-block input#down-payment-range');
            let homeAutoUpdate = true; // update home price if it was not updated or last set to 0
            $('.calc-block .loan-amount input').attr('tabindex', '-1');

            $('.calc-block input:not([type="button"])').on('focusout', function() {
                // remove non-numbers and then remove leading 0s
                let fiedlVal = $(this).val().replace(/\D/g, "").replaceAll(/^0+(?!$)/g, "");
                $(this).val(formatNumber(fiedlVal));
            })

            $('.calc-block input').on('input', function() {
                let homeVal = homeEl.val().replace(/\D/g, "");
                let downVal = downEl.val().replace(/\D/g, "");
                let downPercentVal = downPercentEl.val().replace(/\D/g, "");
                let downPercentRangeVal = downPercentRangeEl.val();
                formatCurrency($(this));

                if ($(this)[0] === homeEl[0]){ // auto update home price when last left blank
                    if (homeVal > 0) homeAutoUpdate = false;
                    else homeAutoUpdate = true;

                    updateDownEl(homeVal, downPercentVal)
                } else if ($(this)[0] === downPercentEl[0]) {
                    downPercentRangeEl.val(downPercentVal || 0) // update slider
                    if (dpr) dpr.style.setProperty('--value', downPercentVal || 0) // update css variable

                    updateDownEl(homeVal, downPercentVal)
                } else if ($(this)[0] === downEl[0]) {
                    if (!homeAutoUpdate) { // use home price to update % down
                        let newDownPercentVal = downVal / homeVal * 100
                        newDownPercentVal = newDownPercentVal.toFixed(0)
                        downPercentEl.val(newDownPercentVal)

                        // update range slider position
                        downPercentRangeEl.val(newDownPercentVal || 0)// update slider
                        if (dpr) dpr.style.setProperty('--value', newDownPercentVal || 0) // update css variable

                        updateLoanEl(homeVal, downVal)
                    } else { // use % down to update home price
                        let newHomeVal = downVal / downPercentVal * 100
                        newHomeVal = newHomeVal.toFixed(0)
                        homeEl.val(formatNumber(newHomeVal))

                        updateLoanEl(newHomeVal, downVal)
                    }
                } else if ($(this)[0] === downPercentRangeEl[0]) {
                    if (downPercentRangeVal > 100 ) downPercentRangeVal = 100
                    downPercentEl.val(downPercentRangeVal)

                    updateDownEl(homeVal, downPercentRangeVal)
                }
            });

            function updateDownEl (homeVal, percent) {
                let newDownVal = homeVal * percent / 100
                newDownVal = newDownVal.toFixed(0)
                downEl.val(formatNumber(newDownVal))

                updateLoanEl(homeVal, newDownVal)
            }

            function updateLoanEl (homeVal, downVal) {
                if (parseInt(homeVal) > parseInt(downVal)) {
                    let newLoanVal = (homeVal - downVal).toString()
                    loanEl.val("$" + formatNumber(newLoanVal))
                } else {
                    loanEl.val("$0")
                }
            }
        }

        $('.form-tooltip-btn').on('click', function(event) {
            // hacky fix - force height 'change' to adjust container height for tooltip on mobile
            event.target.closest('.gform_fields').style.height = 'unset';
            event.target.closest('.gform_fields').style.height = 'auto';
            $(this).parent().toggleClass('active');
        });
    });

    $(document).on('click', function(event) {
        if (!event.target.closest('.form-tooltip')) {
            $('.form-tooltip').removeClass('active');
        }
    });

    $(document).on('gform_confirmation_loaded', function() {
        $('.af-single-form__form').addClass('form-submitted'); // remove min-height
        $('.af-wave').fadeIn(); // show wave block
    });
});